import { Component } from "@angular/core";
import { BaseComponent, IDatatableStateSaveableComponent } from "@impacgroup/angular-baselib";

@Component({
    selector: "app-visitreports-main",
    templateUrl: "./visitreports.main.component.html",
    standalone: false
})
export class VisitReportsMainComponent extends BaseComponent implements IDatatableStateSaveableComponent {
    public listStateData: any;
}
